import {
    Button,
    Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { getLegalServices } from "../../../../src/ApiServices/Apifun";
import { setselectedTab } from "../../../../src/Store/B2bslice";

const LegalServices = () => {
    const [btnLoading, setBtnLoading] = useState(false);
    const [redirect_url, setredirect_url] = useState("");
    const [DataSource, setDataSource] = useState([]);


    const getlegalData = () => {
        setBtnLoading(true);
        getLegalServices()
            .then((res) => {
                setDataSource(res.data);
                setredirect_url(res.redirect_url)
            })
            .catch((err) => console.log(err))
            .finally(() => setBtnLoading(false));
    };

    useEffect(() => {
        getlegalData();
        setselectedTab(14.78);
    }, []);

    const handleRedirect = () => {
        if (DataSource) {
            const form = document.createElement("form");
            form.method = "POST";
            form.action = redirect_url;
            form.target = "_blank";
            form.style.display = "none";

            Object.entries(DataSource).forEach(([key, value]) => {
                if (key !== "redirect_url") {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                }
            });

            document.body.appendChild(form);
            form.submit();
        } else {
            console.error("Redirect URL is missing in the response.");
        }
    };


    return (
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4 p-4">
            <Spin spinning={btnLoading}>
                <div className="w-full bg-white rounded-3xl shadow-md p-6 border border-gray-200 animate-fade-in">
                    <div className="mb-4">
                        <h2 className="text-xl font-semibold text-gray-800">
                            Legal Services Portal
                        </h2>

                    </div>

                    <Button
                        type="primary"
                        className="mt-4 bg-primary hover:bg-primary text-white text-center  flex  items-center px-6 py-2 rounded-lg"
                        onClick={handleRedirect}
                        loading={btnLoading}
                    >
                        Go to Legal Services
                    </Button>
                </div>
            </Spin>
        </div>
    );
};

export default LegalServices;
